BookingApp.service('FlightServices',['$http','$filter','$q',function($http,$filter,$q){
    var request,MinPrice = 0,MaxPrice = 0;
    //var hotels = { buses:[],status:'Not-Set' };

    this.getFlights = function(request){
        var delay = $q.defer();
        //console.log(request);
        $http({
            method: 'POST',
            url: '/flights/search',
            data:request,
            headers:{'X-Requested-With':'XMLHttpRequest'},
        }).then(function successCallback(response) {
            // this callback will be called asynchronously
            // when the response is available
            delay.resolve( response.data );
        }, function errorCallback(response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            //console.log(response.data);

            delay.resolve( response.data );
        });

        return delay.promise;
    }

    this.setMinMaxPrice = function (flights) {
        MinPrice = 99999999;
        MaxPrice = 0;
        angular.forEach(flights,function (flight) {
            var priceString = $filter('number')(flight.Fare.TotalFare,0);
            var price = parseInt(priceString.replace(',',''));
            //console.log(price);
            //console.log();
            //Set MinPrice
            if(price > MaxPrice){
                MaxPrice = price
            }
            //Set MaxPrice
            if(price < MinPrice){
                MinPrice = price
            }
        })
    }

    this.getFlightDetail = function(traceid,Index){
        var delay = $q.defer();
        $http({
            method: 'POST',
            url: '/flights/detail/' + traceid + '/' + Index,
            headers:{'X-Requested-With':'XMLHttpRequest'},
        }).then(function successCallback(response) {
            delay.resolve(response.data);
        },function errorCallback(response){
            delay.resolve(response.data);
        })
        return delay.promise;
    }

    this.getAirportCity = function(code){
        var q = $q.defer();
        $http({
            method:'POST',
            url:'/flights/get-city-detail/' + code
        }).then(function (r) { q.resolve(r.data) },function (r) { q.reject(r.data) })
        return q.promise;
    }

    this.getPrice 				= function(type){	return (type == 'min') ? MinPrice : MaxPrice;	}

}]);